import React, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import { IBookingObj } from '@types';
import { Icons } from '@assets';
import { useSelector } from 'react-redux';
import { authInfoSelect } from '@entities/auth';
import { selectStatusBookingOptions } from '@utils/const';
import ReactDOM from 'react-dom';

const apiUrl = process.env.REACT_APP_API_URL;

interface IProps {
    record: IBookingObj;
}

const StatusSelector = (props: IProps) => {
    const { shop } = useSelector(authInfoSelect);
    const { record } = props;
    const [switchIsOpen, setSwitchIsOpen] = useState(false);
    const [selectorValue, setSelectorValue] = useState<number>(
        record.state || 0
    );
    const [dropdownPosition, setDropdownPosition] = useState({
        top: 0,
        left: 0,
    });

    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (
            selectorValue !== 0 &&
            record &&
            shop &&
            selectStatusBookingOptions[selectorValue]
        ) {
            const bookingUpdateUrl = `${apiUrl}/shops/${shop.id}/booking/${record.id}/${selectStatusBookingOptions[selectorValue].value}`;
            const bodyReq = {
                state: selectorValue,
            };
            fetch(bookingUpdateUrl, {
                // credentials: 'include',
                method: 'POST',
                body: JSON.stringify(bodyReq),
                headers: {
                    accept: 'application/json',
                    Authorization: `${localStorage.getItem('accessToken')}`,
                    'Content-Type': 'application/json',
                },
            })
                .then(res => res.json())
                .catch(() => []);
        }
    }, [selectorValue, record, shop]);

    const swithHandler = (key: number) => {
        if (key !== selectorValue) {
            setSelectorValue(key);
        }
        setSwitchIsOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (
                containerRef.current &&
                !containerRef.current.contains(event.target)
            ) {
                setSwitchIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [containerRef]);

    const updateDropdownPosition = () => {
        if (containerRef.current) {
            const rect = containerRef.current.getBoundingClientRect();
            setDropdownPosition({
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX,
            });
        }
    };

    useEffect(() => {
        if (switchIsOpen) {
            updateDropdownPosition();
            window.addEventListener('scroll', updateDropdownPosition);
            window.addEventListener('resize', updateDropdownPosition);
        }
        return () => {
            window.removeEventListener('scroll', updateDropdownPosition);
            window.removeEventListener('resize', updateDropdownPosition);
        };
    }, [switchIsOpen]);

    return (
        <>
            <NoiseNameContainer
                ref={containerRef}
                key={'container'}
                id={'container'}
                onClick={event => event.stopPropagation()}
            >
                <TitleLabel
                    onClick={() => {
                        setSwitchIsOpen(!switchIsOpen);
                    }}
                >
                    {selectStatusBookingOptions[selectorValue]
                        ? selectStatusBookingOptions[selectorValue]?.label
                        : 'Новая заявка'}
                </TitleLabel>
                <NoiseSelectorBtn>
                    {switchIsOpen ? (
                        <img src={Icons.IconArrowUp} alt="Proga.pro arrow" />
                    ) : (
                        <img
                            src={Icons.IconArrowDown}
                            alt="Proga.pro arrow down"
                        />
                    )}
                </NoiseSelectorBtn>
            </NoiseNameContainer>

            {switchIsOpen &&
                ReactDOM.createPortal(
                    <SelectorDropdown
                        style={{
                            position: 'absolute',
                            top: `${dropdownPosition.top}px`,
                            left: `${dropdownPosition.left}px`,
                        }}
                        onClick={e => e.stopPropagation()}
                    >
                        {selectStatusBookingOptions?.map((item, ind) => {
                            return ind === selectorValue ? null : (
                                <React.Fragment key={ind}>
                                    <TitleLabel
                                        decl={item.key === 'discard'}
                                        onClick={() => swithHandler(ind)}
                                    >
                                        <span>{item.label}</span>
                                    </TitleLabel>
                                    {ind === 1 && <Br />}
                                </React.Fragment>
                            );
                        })}
                    </SelectorDropdown>,
                    document.body
                )}
        </>
    );
};

export default StatusSelector;

const Br = styled.div`
    width: 90%;
    height: 1px;
    border: 1px solid #eeefef;
    align-self: center;
`;
const TitleLabel = styled.div<{
    decl?: boolean;
}>`
    width: 138px;
    height: 38px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 28px;
    /* identical to box height, or 200% */
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    /* Текст/#333333 текст|кнопки */
    color: #333333;

    & span {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 28px;
        /* identical to box height, or 200% */
        color: ${({ decl }) => (decl ? '#DD1A6A' : '#333333')};
    }
`;

const SelectorDropdown = styled.div`
    width: 133px;
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    z-index: 9999;
    padding-top: 10px;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border: 1px solid rgba(143, 143, 143, 0.3);
    border-radius: 0 0 5px 5px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.2);
`;

const NoiseSelectorBtn = styled.div`
    position: absolute;
    right: 6px;
    top: 4px;
    & svg path {
        fill: #a7a7a7;
    }
`;

const NoiseNameContainer = styled.div`
    /* Frame 195 */
    width: 133px;
    height: 38px;
    justify-content: space-between;
    /* Текст/#FFFFFF текст|иконки|кнопки */
    background: #ffffff;
    box-shadow: 0px 2px 15.2px rgba(0, 0, 0, 0.11);
    z-index: 100;
    position: relative;
    display: flex;
    font-weight: 600;
    font-size: 13px;
    line-height: 26px;
    letter-spacing: 0.02em;
    color: #1f1e24;
    /* text-transform: capitalize; */
    cursor: pointer;
    border: 1px solid #d6dce9;
    border-radius: 8px;
`;
